module.exports = __webpack_public_path__ + "img/stripe-logo.b7edbdb5.png";